<template>
  <section :id="['container-' + index + '-' + factsData.type]" :class="['container-' + factsData.type]">
    <div v-if="!isDesktop || isMultiblock == 'true'" :class="[isMultiblock == 'false' ? 'container-lg' : '' ]">
      <div class="row">
        <div class="col">
          <h2 v-if="factsData.config.title">{{ factsData.config.title }}</h2>
          <div class="row animation-facts" :class="{ show: showAllFacts, hide: !showAllFacts }">
            <template v-for="(field, name, index) in factsData.config.fields">
              <div :class="[isMultiblock == 'false' ? 'col-sm-12 col-md-6 ' : 'col-md-6 col-lg-12' ]" class="table-row" :key="index" :id="index" v-if="field !== '' && field !=='Nein'" v-show="index <= 5 || showAllFacts">
                <div class="row" v-if="field !== '' && field !=='Nein' && field !=='-' && field !=='keine Angabe'">
                  <div class="col-6 table-column">
                    <span v-if="name" class="field-data">{{ name }}</span>
                  </div>
                  <div class="col-6 table-column">
                    <span class="table-icon" v-if="field === true">
                      <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 -10 50 50" style="enable-background:new 0 0 44 42;" xml:space="preserve">
                        <path id="Pfad_3373" class="st0" d="M2.5,14.7l13.6,13.6L42.5,2.8"/>
                      </svg>
                    </span>
                    <span v-else v-html="field"></span>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <ButtonComponent v-if="Object.keys(factsData.config.fields).length > 5" class="primary" :onClick="loadMore">
            <span v-if="!showAllFacts">Mehr Daten anzeigen</span>
            <span v-else>Weniger Daten anzeigen</span>
          </ButtonComponent>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container-lg">
        <div class="row">
          <h2 v-if="factsData.config.title">{{ factsData.config.title }}</h2>
          <template v-for="(field, name, index) in factsData.config.fields">
            <div class="col-md-3 col-lg-2 table-row-desktop" :key="index" :id="index" v-if="field !== '' && field !=='Nein' && field !=='-' && field !=='keine Angabe'">
              <div class="row table-column-desktop">
                <span class="col-12 field-data table-icon" v-if="field === true">
                  <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 -10 50 50" style="enable-background:new 0 0 44 42;" xml:space="preserve">
                    <path id="Pfad_3373" class="st0" d="M2.5,14.7l13.6,13.6L42.5,2.8"/>
                  </svg>
                </span>
                <span v-else class="col-12 field-data" v-html="field"></span>
                <span class="col-12 field-name" v-if="name">{{ name }}</span>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <hr v-if="isMultiblock != 'true'" class="horizontal-line">
  </section>
</template>

<script>

import ButtonComponent from "./ButtonComponent.vue";

export default {
   components: {
    ButtonComponent,
  },
  props: {
    factsData: {
      type: Object
    },
    index: {
      type: Number
    },
    isMultiblock: {
			type: String
		},
  },
  data () {
    return {
      showAllFacts: false,
      innerWidth: 0,
    }
  },
  methods: {
    loadMore() {
      this.showAllFacts = !this.showAllFacts;
    },
  },
  created() {
		this.innerWidth = window.innerWidth;
		window.addEventListener('resize', () => {
			this.innerWidth = window.innerWidth;
		});
	},
	computed: {
		isDesktop() {
			return this.innerWidth >= 991;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-turin/factsComponent.scss";
</style>